<template>
    <div>
        <el-menu class="el-menu-vertical-demo" :router="true">
            <el-select v-model="$i18n.locale" :placeholder="$t('shared.selectLanguage')" class="language-select" size="small">
                <el-option :label="$t('shared.english')" value="en" class="language-select">
                    <span>{{$t('shared.english')}}</span>
                </el-option>
                <el-option :label="$t('shared.french')" value="fr" class="language-select">
                    <span>{{$t('shared.french')}}</span>
                </el-option>
            </el-select>
            <li class="action-button" style="text-align:center;">
                <small>{{$t('shared.loggedIn')}}{{$currentUser.profile.name}}</small>
                <el-button type="text" @click="changePassword">{{$t('shared.changePassword')}}</el-button>
                <el-button type="text" @click="signout" style="margin-left: 0" v-if="!$isImpersonateUser">{{$t('shared.logout')}}</el-button>
                <el-button type="text" @click="returnToAdminAccount" style="margin-left: 0" v-if="$isImpersonateUser">{{$t('shared.returnToMyAccount')}}</el-button>
            </li>
            <li class="action-button" v-if="$isUser || $isSubAgentUser">
                <el-button style="overflow: hidden;" @click="$emit('place-order')">{{$t('shared.orderParts')}}</el-button>
            </li>
            <li class="action-button" v-if="$isUser">
                <el-button style="overflow: hidden;" @click="$emit('new-claim')">{{$t('shared.newClaim')}}</el-button>
            </li>
            <div :style="{ display: 'flex', justifyContent: 'center', border: store.state.count > 0 ? '5px solid red' : 'none' }" v-if="$isAdmin">
                <p :style="{ color: store.state.count > 0 ? 'red' : 'black' }">Costco Service Requests: {{ store.state.count }}</p>
            </div>
            <li class="action-button" v-if="$isFullAdmin">
                <el-button style="overflow: hidden;" @click="$emit('new-service-ticket')">{{$t('shared.newServiceTicket')}}</el-button>
            </li>
            <li class="action-button" v-if="$isFullAdmin">
                <el-button style="overflow: hidden;" @click="$emit('register-equipment')">{{$t('shared.registerEquipment')}}</el-button>
            </li>

            <el-menu-item index="/" id="dashboard-special" :class="{'is-active': isDashboard}">
                <i class="el-icon-menu"></i>
                <span>{{$t('shared.dashboard')}}</span>
            </el-menu-item>

            <el-menu-item index="/claims" :class="{'is-active': isClaims}" v-if="!$isSubAgentUser">
                <i class="el-icon-tickets"></i>
                <span>{{$t('dashboard.claims')}}</span>
            </el-menu-item>

            <el-menu-item index="/FAQ" :class="{'is-active': isClaimsFAQ}" v-if="$isUser">
                <i class="el-icon-question"></i>
                <span>{{$t('shared.claimsFAQ')}}</span>
            </el-menu-item>

            <el-menu-item index="/rma" :class="{'is-active': isRma}" v-if="$isAdmin">
                <i class="el-icon-tickets"></i>
                <span>{{$t('claims.rma')}}</span>
            </el-menu-item>

            <el-menu-item index="/accounting" v-if="$isAdmin">
                <i class="el-icon-view"></i>
                <span>{{$t('common.accounting')}}</span>
            </el-menu-item>

            <el-menu-item index="/service-tickets" :class="{'is-active': isServiceTickets}" v-if="$isAdmin">
                <i class="el-icon-service"></i>
                <span>{{$t('dashboard.serviceTickets')}}</span>
            </el-menu-item>

            <el-menu-item index="/escalation-tickets" :class="{'is-active': isEscalationTickets}" v-if="$isAdmin" @click="openInNewTab('/#/escalation-tickets')">
                <i class="el-icon-service"></i>
                <span>Escalation Report</span>
            </el-menu-item>

            <el-menu-item index="/emails" v-if="$isAdmin">
                <i class="el-icon-message"></i>
                <span>Emailed Service Tickets</span>
            </el-menu-item>

            <el-menu-item index="/costco-service-requests" :class="{'is-active': isCostcoServiceRequests}" v-if="$isAdmin">
                <i class="el-icon-service"></i>
                <span>{{$t('dashboard.CostcoServiceRequests')}} ({{store.state.count}})</span>
            </el-menu-item>

            <el-menu-item index="/part-orders" :class="{'is-active': isPartOrders}">
                <i class="el-icon-goods"></i>
                <span>{{$t('common.partOrders')}}</span>
            </el-menu-item>

            <el-menu-item index="/equipment" v-if="$isAdmin">
                <i class="el-icon-location"></i>
                <span>{{$t('common.equipment')}}</span>
            </el-menu-item>

            <el-submenu index="/reports">
                <template slot="title">
                    <i class="el-icon-view"></i>
                    <span>{{$t('shared.reports')}}</span>
                </template>

                <el-menu-item index="/reports/costco" v-if="$isAdmin">Costco</el-menu-item>
                <el-menu-item index="/reports/claims" v-if="$isAdmin">{{$t('shared.claimHistory')}}</el-menu-item>
                <el-menu-item index="/reports/servicetickets" v-if="$isAdmin">{{$t('dashboard.serviceTickets')}}</el-menu-item>
                <el-menu-item index="/reports/parts" v-if="$isUser">{{$t('shared.priceList')}}</el-menu-item>
                <el-menu-item index="/reports/resolutioncodes" v-if="$isUser">{{$t('shared.resolutionCodes')}}</el-menu-item>
                <el-menu-item index="/reports/usedparts" v-if="$isUser">{{$t('shared.usedParts')}}</el-menu-item>
                <el-menu-item index="/reports/rma" :class="{'is-active': isRmaReport}" v-if="$isAdmin">R&D RMAs</el-menu-item>
                <el-menu-item index="/reports/simsApReport" v-if="$isAdmin">{{$t('shared.simsAPReport')}}</el-menu-item>
            </el-submenu>

            <el-submenu index="/masters/customers" v-if="$isAdmin">
                <template slot="title">
                    <i class="el-icon-setting"></i>
                    <span>{{$t('shared.masterData')}}</span>
                </template>

                <el-menu-item index="/masters/customers">{{$t('shared.customers')}}</el-menu-item>
                <el-menu-item index="/masters/customersnotifications">{{$t('shared.customersNotifications')}}</el-menu-item>
                <el-menu-item index="/masters/customer-chains">{{$t('shared.customerChains')}}</el-menu-item>
                <el-menu-item index="/masters/service-companies">{{$t('shared.serviceCompanies')}}</el-menu-item>
                <el-menu-item index="/masters/products">{{$t('shared.products')}}</el-menu-item>
                <el-menu-item index="/masters/parts">{{$t('common.parts')}}</el-menu-item>
                <el-menu-item index="/masters/resolution-codes">{{$t('shared.resolutionCodes')}}</el-menu-item>
                <el-menu-item index="/masters/resolution-code-categories" v-if="$isFullAdmin">{{$t('shared.resolutionCodeCategories')}}</el-menu-item>
                <el-menu-item index="/masters/complaint-codes">{{$t('serviceTickets.symptomCodes')}}</el-menu-item>
                <el-menu-item index="/masters/canadian-taxes">{{$t('shared.canadianTaxes')}}</el-menu-item>
                <el-menu-item index="/masters/users" v-if="$isFullAdmin">{{$t('shared.users')}}</el-menu-item>
            </el-submenu>
        </el-menu>
        <div style="padding-left: 20px; padding-top: 10px; display: flex; align-items: center;">
            <el-switch v-model="isGmailActive" @change="updateGmailConfiguration"></el-switch>
            <p style="margin-left: 10px;">Gmail Email Delivery</p>
        </div>

    <change-password-dialog :visible="passwordChangeVisible" @dialogClosed="passwordChangeVisible = false"></change-password-dialog>
    </div>
</template>

<script>
    import ChangePasswordDialog from "@/app/shared/components/ChangePasswordDialog";
    import store from "@/app/costcoservicerequests/store.js";
    import axios from 'axios';

    export default {
        name: "navigation",
        components: {
            ChangePasswordDialog
        },
        data() {
            return {
                passwordChangeVisible: false,
                language: "en",
                costcoServiceRequestsCount: 0,
                isGmailActive: false,
                store
            };
        },
        computed: {
            isDashboard() {
                return this.$route.path === '/';
            },
            isClaims() {
                return this.$route.path.includes('claims');
            },
            isServiceTickets() {
                return this.$route.path.includes('service-tickets');
            },
            isEscalationTickets() {
                return this.$route.path.includes('escalation-tickets');
            },
            isCostcoServiceRequests() {
                return this.$route.path.includes('costco-service-requests');
            },
            isPartOrders() {
                return this.$route.path.includes('part-orders');
            },
            isClaimsFAQ()
            {
                return this.$route.path.includes('FAQ');
            },
            isRma() {
                return this.$route.path == '/rma';
            },
            isRmaReport() {
                return this.$route.path == '/reports/rma';
            }
        },
        methods: {
            openInNewTab(url) {
                window.open(url, '_blank');
            },
            signout() {
                window.localStorage.clear();
                window.document.cookie = "browserClosed=" + new Date().getTime();
                window.localStorage.setItem("browserClosed", new Date().getTime());
                window.signInManager.signoutRedirect();

            },
            changePassword() {
                this.passwordChangeVisible = true;
            },
            returnToAdminAccount() {
                axios.get('/api/account/returnToAccount').then(response => {
                    axios.defaults.headers.common['Authorization'] = response.data.token;
                    localStorage.removeItem("isImpersonateUser");
                    window.signInManager.signinRedirect();
                });
            },
            updateGmailConfiguration() {
                var data = {};
                data.isActive = this.isGmailActive;
                data.name = 'Gmail';

                var message = data.isActive ? this.$t('common.turnGmailOn') : this.$t('common.turnGmailOff');

                this.$confirm(
                    message,
                    'Warning',
                    {
                        confirmButtonText: this.$t('common.OK'),
                        cancelButtonText: this.$t('common.cancel'),
                        type: 'warning'
                    }
                ).then((res) => {
                    axios.post('api/gmail-configuration', data).then((response) => {
                        this.isGmailActive = response.data.isActive;
                    })
                }).catch(_ => {
                    this.isGmailActive = !this.isGmailActive;
                });
            }
        },
        mounted() {
            axios.get('api/service-requests/count').then((response) => {
                if (response.data.count) {
                    this.store.setCount(response.data.count);
                }
            });

            axios.get('api/gmail-configuration').then((response) => {
                this.isGmailActive = response.data.isActive;
            })
        },
        updated() {
            axios.get('api/service-requests/count').then((response) => {
                if (response.data.count) {
                    this.store.setCount(response.data.count);
                }
            });
        }
    };
</script>

<style scoped>
    .select-language {
        width: 20px;
        height: 20px
    }
    .language-select {
        padding: 5px 10px;
        display: block;
    }
    .action-button {
        padding: 5px 10px;
    }

        .action-button .el-button {
            width: 100%;
        }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/Navigation.vue